import Vue from 'vue'
import { toApiAddress } from '@/utils/address-helper';

import axiosIntents from '@/utils/axios-intents'

import dynStorage from '@/utils/storage-dynamic'

import {
    AVAILABLE_SIM_TYPE_PRODUCTS,
    AVAILABLE_SIM_TYPE_PRODUCTS_BY_UUID,
    TRAVEL_ESIM_ITEM_VARIANT_UUID,

    eshopItem,

    logAnalyticsItems
} from '@/helpers/eshop'

const ESHOP_V2_CART = 'eshop-v2-cart'
const ESHOP_V2_PURCHASED = 'eshop-v2-purchased'
const ESHOP_V2_CHECKOUT_FLOW = 'eshop-v2-checkout-flow'

const eshopCartItemSim_v2 = (eshop_item, sim, plan) => {
    const item = eshop_item ? {
        UUID: eshop_item.UUID,
        PriceCents: eshop_item.PriceCents,
            Name: eshop_item.Name,
            Type: eshop_item.Type,
            VirtualType: eshop_item.VirtualType,
        ItemUUID: eshop_item.ItemUUID,
        // SelfManaged: eshop_item.SelfManaged, // Don't send SelfManaged in payload
        ServiceType: 'MOBILE',
        Quantity: eshop_item.Quantity,

        Attributes: {
            SetupMobileGroup: eshop_item.Attributes?.SetupMobileGroup,
            RequestedForName: eshop_item.Attributes?.RequestedForName,
            MobileGroupOwnerMobileUUID: eshop_item.Attributes?.MobileGroupOwnerMobileUUID,
            SetupBillRouting: eshop_item.Attributes?.SetupBillRouting,
            CustomerCreation: eshop_item.Attributes?.CustomerCreation,
            ReplacesMobileUUID: eshop_item.Attributes?.ReplacesMobileUUID,
            BecomeGroupOwner: eshop_item.Attributes?.BecomeGroupOwner,

            PortingAccountLSP: eshop_item.Attributes?.PortingAccountLSP,
            PortingCarrierLSP: eshop_item.Attributes?.PortingCarrierLSP,
            PortingNametagLSP: eshop_item.Attributes?.PortingNametagLSP,
            PortingPriorSIMID: eshop_item.Attributes?.PortingPriorSIMID,
            PortingOverMSISDN: eshop_item.Attributes?.PortingOverMSISDN,
            PreSelectedMSISDN: eshop_item.Attributes?.PreSelectedMSISDN,
            PortingOverMSISDNType: eshop_item.Attributes?.PortingOverMSISDNType,
        },

        Products: [
            eshopCartItemProduct_v2(eshop_item.Products[0], plan),
        ],
    } : sim ? {
        UUID: null,
        PriceCents: 0, // PriceCents for SIM comes from BE (for now it is 500 for Physical SIM and 0 for eSIM)
        ...(sim.UUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID ? {
            Name: 'eSIM',
            Type: 'TYPE_VIRTUAL',
            VirtualType: 'VT_ESIM',
        } : {
            Name: 'SIM Card',
            Type: 'TYPE_PRODUCT',
            PhysicalType: 'SIM',
        }),
        ItemUUID: sim.UUID,
        SelfManaged: sim.SelfManaged === true,
        ServiceType: 'MOBILE',

        Attributes: {
            SetupMobileGroup: sim.Grouped,
            RequestedForName: sim.GroupMemberName,
            MobileGroupOwnerMobileUUID: sim.MobileGroupOwnerMobileUUID,
            SetupBillRouting: sim.UseMasterBillingAccount,
            CustomerCreation: sim.CustomerCreation,
            BecomeGroupOwner: sim.BecomeGroupOwner,
        },

        Products: [
            eshopCartItemProduct_v2(null, plan),
        ],
    } : null

    if (item.Products[0] == null) {
        item.Products.length = 0
    }

    // item.SPID = store.getters.app_spid
    // item.Quantity = 1
    item.Description = item.Name

    return item
}

const eshopCartItemProduct_v2 = (eshop_item, plan) => {
    const item = eshop_item ? {
        UUID: eshop_item.UUID,
        Name: eshop_item.Name,
        Description: eshop_item.Description,
        PriceCents: eshop_item.PriceCents,
        PriceCatalogCents: eshop_item.PriceCatalogCents,
        Type: eshop_item.Type,
        VirtualType: eshop_item.VirtualType,
        ServiceType: 'MOBILE',
        Quantity: eshop_item.Quantity,
        Attributes: {
            BillingReference: eshop_item.Attributes.BillingReference,
            MobileProductAvailabilityUUID: eshop_item.Attributes.MobileProductAvailabilityUUID,
            MobileProductCatalogUUID: eshop_item.Attributes.MobileProductCatalogUUID,
            AutoRenew: eshop_item.Attributes.AutoRenew,
            DiscountUUID: eshop_item.Attributes.DiscountUUID,
        },
    } : plan ? {
        UUID: null,
        Name: plan.merged_name
            || `${ plan.Availabilities[0].RetailName } (${
                plan.is_payg
                    ? 'Payg'
                    : plan.ProductType == 'postpaymobile'
                        ? 'Postpay'
                        : process.env.VUE_APP_ESHOP_CART_ITEM_PREPAY
            })`,
        Description: plan.Availabilities[0].RetailDescription,
        PriceCents: plan.Availabilities[0].RetailCents,
        PriceCatalogCents: plan.price_catalog_cents,
        Type: 'TYPE_VIRTUAL',
        VirtualType: 'VT_PLAN',
        ServiceType: 'MOBILE',
        Attributes: {
            BillingReference: plan.is_payg
                ? 'payg'
                : plan.ProductType == 'postpaymobile'
                    ? 'postpay'
                    : 'prepay',
            MobileProductAvailabilityUUID: plan.Availabilities[0].UUID,
            MobileProductCatalogUUID: plan.Availabilities[0].ProductCatalogEntryUUID,
            AutoRenew: Boolean(plan.is_autoRenew),
            DiscountUUID: plan.DiscountUUID,
        },
    } : null

    // item.SPID = store.getters.app_spid
    // item.Quantity = 1
    // item.Description =

    return item
}

// Rebuild a travel eSIM cart item from existing cart data, preserving ALL plan
// products (one per destination). Isolated from eshopCartItemSim_v2, which keeps
// only Products[0]. Used for travel re-save / checkout payloads.
const eshopCartItemTravelSim_v2 = (sim) => ({
    UUID: sim.UUID,
    PriceCents: sim.PriceCents || 0,
    Name: sim.Name,
    Type: sim.Type,
    VirtualType: sim.VirtualType,
    ItemUUID: sim.ItemUUID,
    ItemVariantUUID: sim.ItemVariantUUID ?? null,
    SelfManaged: true,
    ServiceType: 'MOBILE',
    Description: sim.Description || sim.Name,
    Attributes: {
        RequestedForName: sim.Attributes?.RequestedForName || '',
        CustomerCreation: sim.Attributes?.CustomerCreation || 'BrandNewCustomer',
    },
    Products: (sim.Products || []).map(product => ({
        UUID: product.UUID,
        Name: product.Name,
        Description: product.Description,
        PriceCents: product.PriceCents,
        PriceCatalogCents: product.PriceCatalogCents,
        Type: product.Type,
        VirtualType: product.VirtualType,
        ServiceType: 'MOBILE',
        Attributes: {
            BillingReference: product.Attributes?.BillingReference,
            MobileProductAvailabilityUUID: product.Attributes?.MobileProductAvailabilityUUID,
            MobileProductCatalogUUID: product.Attributes?.MobileProductCatalogUUID,
            AutoRenew: product.Attributes?.AutoRenew,
            DiscountUUID: product.Attributes?.DiscountUUID,
        },
    })),
})

const eshopCartItemsMultiPlansSelfManaged_v2 = ({ items, is_mobile_group_sim_order = false } = {}) => {
    const count = items.length

    if (items) {
        for (let i = 0; i < count; i++) {
            if (items[i].SelfManaged) {
                items[i].SelfManaged = false
                items[i].Attributes.CustomerCreation = process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON
            } else {
                items[i].Attributes.CustomerCreation = 'BrandNewCustomer'
            }
        }

        // Всегда устанавливаем SelfManaged для 1й SIM-ки
        // Если не is_mobile_group_sim_order
        // commented under the terms of RSL-1043 task
        /* if (!is_mobile_group_sim_order) {
            items[0].SelfManaged = true
        } */
    }

    return items
}

/*fwa consts */
const eshopFWACartItemSim_v2 = (eshop_item,contact, sim, plan, broadband_device, init = false) => {
    const item = eshop_item ? {
        UUID: eshop_item.UUID,
        SPID: eshop_item.SPID,
        ItemUUID: eshop_item.ItemUUID,
        ItemVariantUUID: eshop_item.ItemVariantUUID,
        Type: 'TYPE_PRODUCT',
        VirtualType: 'VT_NONE',
        ServiceType: 'FWA',
        PhysicalType: 'SIM',
        Name: 'SIM Card',
        Brand: '',
        Description: "SIM Card",
        Quantity: 1,
        PriceCents: 0,
        AmountCents: 0,
        AmountTaxCents: 0,
        PriceCatalogCents: 0,
        AmountPaidCents: 0,
        AmountIncludesTax: false,
        ItemImages: null,
        Status: "CART",
        Shipped: false,
        Delivered: false,
        Tracking: "",
        TrackingURL: "",
        TrackingNumber: "",
        TrackingCarrier: "",
        Attributes: {
            ESIMInfo: {
                ID: "",
                Data: "",
                ConfirmationCode: ""
            },
            ReplacesMobileUUID: "",
            BillingReference: "",
            SetupBillRouting: false,
            BillRouteCustomerUUID: "",
            CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON,
            MobileGroupOwnerMobileUUID: "",
            DesiredGroupType: "",
            BecomeGroupOwner: false,
            SetupMobileGroup: false,
            RequestedForName: "",
            PortingOverMSISDN: "",
            PortingCarrierLSP: 0,
            PortingAccountLSP: "",
            PortingNametagLSP: "",
            PortingPriorSIMID: "",
            AddIdentityAccess: false,
            PreSelectedMSISDN: "",
            FWAAttributes: eshop_item.Attributes?.FWAAttributes || null,
            Contact: {
                PhoneNumber: contact
            }
        },

        Products: [
            ...eshopFWACartItemProduct_v2(
                filterPlanInsideOfFWACart(eshop_item.Products),
                plan,
                filterModemInsideOfFWACart(eshop_item.Products) ?? null,
                init
            ),
        ],

        SelfManaged: false,
    }
    : sim ? {
        UUID: null,
        PriceCents: 0,
        ...(sim.UUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID ? {
            Name: 'eSIM',
            Type: 'TYPE_VIRTUAL',
            VirtualType: 'VT_ESIM',
        } : {
            Name: 'SIM Card',
            Type: 'TYPE_PRODUCT',
        }),
        PhysicalType : "SIM",
        ServiceType: "FWA",
        ItemUUID: sim.UUID,
        ItemVariantUUID: sim.ItemVariantUUID ?? null,
        // SelfManaged: sim.SelfManaged === true,

        Attributes: {
            SetupMobileGroup: false,
            SetupBillRouting: false,
            CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
            FWAAttributes: plan.FWA_Attributes
        },

        Products: [
            ...eshopFWACartItemProduct_v2(null, plan, broadband_device, init),
        ],
    } : null

    if (item.Products[0] == null) {
        item.Products.length = 0
    }

    // item.SPID = store.getters.app_spid
    // item.Quantity = 1
    item.Description = item.Name

    return item
}

const eshopFWACartItemProduct_v2 = (eshop_item, plan, broadband_device, init = false) => {
    const planItem = eshop_item ? {
        UUID: eshop_item.UUID,
        SPID: eshop_item.SPID,
        ItemUUID: eshop_item.ItemUUID,
        Type: "TYPE_VIRTUAL",
        VirtualType: "VT_PLAN",//eshop_item.VirtualType,
        PhysicalType: "",
        ServiceType: "FWA",
        Name: eshop_item.Name,
        Brand: "",
        Description: eshop_item.Description,
        Quantity: 1,
        PriceCents: eshop_item.PriceCents,
        AmountCents: eshop_item.AmountCents,
        AmountTaxCents: eshop_item.AmountTaxCents,
        PriceCatalogCents: eshop_item.PriceCatalogCents,
        AmountPaidCents: 0,
        AmountIncludesTax: false,
        ItemImages: null,
        Status: "",
        Shipped: false,
        Delivered: false,
        Tracking: "",
        TrackingURL: "",
        TrackingNumber: "",
        TrackingCarrier: "",
        ProductCatalogUUID: eshop_item.ProductCatalogUUID,
        ProductAvailabilityUUID: eshop_item.ProductAvailabilityUUID,
        Attributes: {
            MobileProductCatalogUUID: eshop_item.Attributes?.MobileProductCatalogUUID ?? null,
            MobileProductAvailabilityUUID: eshop_item.Attributes?.MobileProductAvailabilityUUID ?? null,
            AutoRenew: true,
            BillingReference: "postpay",
        },
        Type: eshop_item.Type,
        Products: null,
        SelfManaged: false,

    } : plan ? {
        UUID: null,
        Type: 'TYPE_VIRTUAL',
        VirtualType: 'VT_PLAN',
        PhysicalType: "",
        ServiceType: "FWA",
        Name: plan.Name,
        Brand: "",
        Description: plan.Description,
        Quantity: 1,


        Attributes: {
            BillingReference: 'postpay',
            MobileProductAvailabilityUUID: plan.ID,
            MobileProductCatalogUUID: plan.ProductCatalogUUID,
            AutoRenew: true,
        },
    } : null

    if (broadband_device && typeof broadband_device === "object" &&
        !Array.isArray(broadband_device) && Object.keys(broadband_device).length > 0) {

        const deviceItem = {
            UUID: init
                ? null
                : broadband_device.UUID ?? null,
            PriceCents: broadband_device.PriceCents ?? 0,
            Name: broadband_device.Model ?? 'MODEM',
            Type:  "TYPE_PRODUCT",
            PhysicalType : "MODEM",
            ServiceType: "FWA",
            ItemUUID: broadband_device.UUID,
            ItemVariantUUID: broadband_device.ItemVariantUUID ?? null,
            // SelfManaged: sim.SelfManaged === true,

            Attributes: {
                SetupMobileGroup: false,
                SetupBillRouting: false,
                CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
            },
        }

        return [planItem, deviceItem]
    }

    return [planItem]
}

/*ufb consts */

const eshopUFBCartItemPlan_v2 = (eshop_item, plan, broadband_device, broadband_flow, init = false) => {

    const isTransfer = broadband_flow?.transfer?.required === true

    // Debug: Log the transfer data to understand what we're working with
    console.log('eshopUFBCartItemPlan_v2 - broadband_flow.transfer:', broadband_flow?.transfer)
    console.log('eshopUFBCartItemPlan_v2 - transfer.required:', broadband_flow?.transfer?.required)

    const planItem = eshop_item ? {
        UUID: eshop_item.UUID,
        SPID: eshop_item.SPID,
        ItemUUID: eshop_item.ItemUUID,
        ItemVariantUUID: eshop_item.ItemVariantUUID,
        Type: "TYPE_VIRTUAL",
        VirtualType: "VT_PLAN",
        PhysicalType: "",
        ServiceType: "UFB",
        Name: eshop_item.Name,
        Brand: "",
        Description: eshop_item.Description,
        Quantity: 1,
        PriceCents: eshop_item.PriceCents || 0,
        AmountCents: eshop_item.AmountCents || 0,
        AmountTaxCents: eshop_item.AmountTaxCents || 0,
        PriceCatalogCents: eshop_item.PriceCatalogCents || 0,
        AmountPaidCents: 0,
        AmountIncludesTax: false,
        ItemImages: null,
        Status: "CART",
        Shipped: false,
        Delivered: false,
        Tracking: "",
        TrackingURL: "",
        TrackingNumber: "",
        TrackingCarrier: "",
        ProductCatalogUUID: plan.ProductCatalogUUID,
        ProductAvailabilityUUID: plan.ID,
        Identifier: eshop_item.Identifier,
        Attributes: {
            CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
            BillingReference: "postpay",
            MobileProductAvailabilityUUID: eshop_item.Attributes?.MobileProductAvailabilityUUID ?? null,
            MobileProductCatalogUUID: eshop_item.Attributes?.MobileProductCatalogUUID ?? null,
            AutoRenew: true,
            UFBAttributes: {
                PrequalUUID: eshop_item?.Attributes?.UFBAttributes?.PrequalUUID || broadband_flow?.serviceAvailability?.PrequalUUID || null,
                ServiceType: "Managed",
                OrderType: eshop_item.Attributes?.UFBAttributes?.OrderType || (() => {
                    // Always pass ConnectPrimary unless TransferPrimary is explicitly required
                    const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" : "ConnectPrimary";
                    return orderType;
                })(),
                RSFDate: broadband_flow?.rsf?.StartTimeNanos ? Math.floor(broadband_flow.rsf.StartTimeNanos / 1000000000) : Math.floor(Date.now() / 1000),
                ServiceAddress: eshop_item?.Attributes?.UFBAttributes?.ServiceAddress || broadband_flow?.location?.Formatted || "",
                TransferFrom: {
                    Provider: eshop_item?.Attributes?.UFBAttributes?.TransferFrom?.Provider || (isTransfer ? broadband_flow.transfer.provider?.name || "" : ""),
                    AccountHolderName: eshop_item?.Attributes?.UFBAttributes?.TransferFrom?.AccountHolderName || (isTransfer ? broadband_flow.transfer.account?.holder || "" : ""),
                    AccountNumber: eshop_item?.Attributes?.UFBAttributes?.TransferFrom?.AccountNumber || (isTransfer ? broadband_flow.transfer.account?.number || "" : ""),
                    // If there are existing connections, pass the ConnectionID regardless of transfer type
                    ConnectionID: eshop_item?.Attributes?.UFBAttributes?.TransferFrom?.ConnectionID ||
                        (broadband_flow.transfer?.connection?.ID ? broadband_flow.transfer.connection.ID : "")
                }
            }
        },
        Products: broadband_device ? eshopUFBCartItemProduct_v2(
            filterModemInsideOfUFBCart(eshop_item?.Products),
            broadband_device,
            broadband_flow,
            init
        ) : null,
        SelfManaged: false,
    } : plan ? {
        UUID: null,
        ItemUUID: plan.ID,
        ItemVariantUUID: plan.ProductCatalogUUID,
        Type: "TYPE_VIRTUAL",
        VirtualType: "VT_PLAN",
        PhysicalType: "",
        ServiceType: "UFB",
        Name: plan.Name || "",
        Brand: "",
        Description: plan.Description || "",
        Quantity: 1,
        PriceCents: plan.Price || 0,
        AmountCents: plan.Price || 0,
        AmountTaxCents: 0,
        PriceCatalogCents: plan.Price || 0,
        AmountPaidCents: 0,
        AmountIncludesTax: false,
        ItemImages: null,
        Status: "CART",
        Shipped: false,
        Delivered: false,
        Tracking: "",
        TrackingURL: "",
        TrackingNumber: "",
        TrackingCarrier: "",
        ProductCatalogUUID: plan.ProductCatalogUUID,
        ProductAvailabilityUUID: plan.ID,
        Attributes: {
            CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
            BillingReference: "postpay",
            MobileProductAvailabilityUUID: plan.ID,
            MobileProductCatalogUUID: plan.ProductCatalogUUID,
            AutoRenew: true,
            UFBAttributes: {
                PrequalUUID: broadband_flow?.serviceAvailability?.PrequalUUID || null,
                ServiceType: "Managed",
                ServiceAddress: broadband_flow?.location?.Formatted || "",
                OrderType: (() => {
                    // Always pass ConnectPrimary unless TransferPrimary is explicitly required
                    const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" : "ConnectPrimary";
                    return orderType;
                })(),
                RSFDate: broadband_flow?.rsf?.StartTimeNanos
                    ? broadband_flow.rsf.StartTimeNanos
                    : Date.now() * 1000000,
                TransferFrom: {
                    Provider: isTransfer ? broadband_flow.transfer.provider?.name || "": "",
                    AccountHolderName: isTransfer ? broadband_flow.transfer.account?.holder || "" : "",
                    AccountNumber: isTransfer ? broadband_flow.transfer.account?.number || "" : "",
                    // If there are existing connections, pass the ConnectionID regardless of transfer type
                    ConnectionID: broadband_flow.transfer?.connection?.ID ? broadband_flow.transfer.connection.ID : ""
                }
            }
        },
        Products: broadband_device ? eshopUFBCartItemProduct_v2(
            null, broadband_device, broadband_flow, init
        ) : null,
        SelfManaged: false,
    } : null

    return [planItem]
}

const eshopUFBCartItemProduct_v2 = (eshop_item, broadband_device, broadband_flow, init = false) => {

    console.log('eshopUFBCartItemProduct_v2', eshop_item, broadband_device, broadband_flow, init);
    
    if (broadband_device && typeof broadband_device === "object" &&
        !Array.isArray(broadband_device) && Object.keys(broadband_device).length > 0) {

        const deviceItem = {
            UUID: init
                ? null
                : broadband_device.UUID ?? null,
            SPID: null, // Will be set later
            ItemUUID: broadband_device.UUID,
            ItemVariantUUID: broadband_device.ItemVariantUUID ?? null,
            Type: "TYPE_PRODUCT",
            VirtualType: "VT_NONE",
            PhysicalType: "MODEM",
            ServiceType: "UFB",
            Name: broadband_device.Model ?? broadband_device.Name ?? 'UFB Modem',
            Brand: "",
            Description: broadband_device.Description ?? "UFB Modem",
            Quantity: 1,
            PriceCents: broadband_device.PriceCents ?? 0,
            AmountCents: broadband_device.PriceCents ?? 0,
            AmountTaxCents: 0,
            PriceCatalogCents: broadband_device.PriceCents ?? 0,
            AmountPaidCents: 0,
            AmountIncludesTax: false,
            ItemImages: broadband_device.ItemImages || null,
            Status: "CART",
            Shipped: false,
            Delivered: false,
            Tracking: "",
            TrackingURL: "",
            TrackingNumber: "",
            TrackingCarrier: "",
            ProductCatalogUUID: broadband_device.ProductCatalogUUID ?? null,
            ProductAvailabilityUUID: broadband_device.ProductAvailabilityUUID ?? null,
            Attributes: {
                SetupMobileGroup: false,
                SetupBillRouting: false,
                CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
                UFBAttributes: {
                    PrequalUUID: broadband_flow?.serviceAvailability?.PrequalUUID || null,
                    ServiceType: "Managed",
                    OrderType: (() => {
                        const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" :
                            broadband_flow?.transfer?.required === false ? "MultiPrimary" :
                            "ConnectPrimary";
                        return orderType;
                    })(),
                    RSFDate: broadband_flow?.rsf?.StartTimeNanos
                        ? broadband_flow.rsf.StartTimeNanos
                        : Date.now() * 1000000,            
                    ServiceAddress: broadband_flow?.location?.Formatted || "",
                    TransferFrom: {
                        Provider: "",
                        AccountHolderName: "",
                        AccountNumber: "",
                        // If there are existing connections, pass the ConnectionID regardless of transfer type
                        ConnectionID: broadband_flow.transfer?.connection?.ID ? broadband_flow.transfer.connection.ID : ""
                    }
                }
            },
            Products: null,
            SelfManaged: false,
        }

        return [deviceItem]
    }

    return []
}

export function filterModemInsideOfFWACart(Products) {
    const modem = Products.filter(product => product.PhysicalType == "MODEM" && product.Type == "TYPE_PRODUCT")
    return modem.length > 0 ? modem[0] : null
}

export function filterModemInsideOfUFBCart(Products) {
    const modem = Products.filter(product => product.PhysicalType == "MODEM" && product.Type == "TYPE_PRODUCT")
    return modem.length > 0 ? modem[0] : null
}

export function filterPlanInsideOfFWACart(Products) {
    const plan = Products.filter(product => product.VirtualType == "VT_PLAN" && product.Type == "TYPE_VIRTUAL")
    return plan.length > 0 ? plan[0] : null
}

export default {
    state: {
        eshop_v2_cart: {},
        eshop_v2_cart_loading: false,

        eshop_v2_purchased: null,

        eshop_v2_checkout_flows: {},

        isFWAOrder: false,
        isUFBOrder: false,

        // Marks the current cart as a travel eSIM order so the checkout can use
        // the dedicated travel cart rendering (isolated from the local flow).
        isTravelOrder: false,

        // Separate cart for UFB Move House (isolated from purchase flow)
        eshop_v2_move_house_cart: {},
    },
    getters: {
        eshop_v2_cart: state => state.eshop_v2_cart,
        eshop_v2_cart_uuid: state => state.eshop_v2_cart.UUID,
        eshop_v2_cart_number: state => state.eshop_v2_cart.Number,

        eshop_v2_cart_sims: state => state.eshop_v2_cart.Items?.filter(item =>
            item.ItemUUID in AVAILABLE_SIM_TYPE_PRODUCTS_BY_UUID
            || (item.ServiceType === 'MOBILE' && item.ItemVariantUUID === TRAVEL_ESIM_ITEM_VARIANT_UUID)
        ) || [],

        eshop_v2_cart_fwa_sims: state => state.eshop_v2_cart.Items?.filter(item =>
            item.ServiceType === 'FWA' && item.PhysicalType === 'SIM'
        ) || [],

        eshop_v2_cart_loading: state => state.eshop_v2_cart_loading,

        // Move House cart getters (separate from purchase cart)
        eshop_v2_move_house_cart: state => state.eshop_v2_move_house_cart,
        eshop_v2_move_house_cart_uuid: state => state.eshop_v2_move_house_cart.UUID,
        eshop_v2_move_house_cart_number: state => state.eshop_v2_move_house_cart.Number,

        eshop_v2_cart_items: state => {
            if (!state.eshop_v2_cart.Items || !Array.isArray(state.eshop_v2_cart.Items) || state.eshop_v2_cart.Items.length === 0) {
                return [];
            }

            return state.eshop_v2_cart.Items.reduce((acc, eshop_item) => {
                /** @text */
                const specifications = [
                    eshop_item.VirtualType == 'VT_ESIM' ? 'eSIM' : 'Physical SIM',
                    (!(eshop_item?.Products?.[0]?.Attributes?.AutoRenew) ? 'Non ' : '') + 'Auto Renew',
                ]
                if (eshop_item.Attributes?.CustomerCreation === process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON) { specifications.push('Self Manage') }

                if (eshop_item.Grouped || eshop_item.Attributes?.SetupMobileGroup) { specifications.push('Added To The Group') }

                if (eshop_item.UseMasterBillingAccount || eshop_item.Attributes?.SetupBillRouting) { specifications.push('Charged To Me') }

                // Handle UFB items
                if (eshop_item.ServiceType === "UFB") {
                    if (eshop_item.Products?.[0]) { // UFB plan with device
                        console.log('adding UFB items (Plan + Device) into the shopping cart')
                        acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: 'UFB Plan', specifications: [] }))
                        acc.push(eshopItem(eshop_item.Products[0], { UUID: eshop_item.Products[0].UUID }))
                    } else { // UFB plan only
                        console.log('adding UFB plan only into the shopping cart')
                        acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: 'UFB Plan', specifications: [] }))
                    }
                }
                // Handle FWA items
                else if (eshop_item.ServiceType === "FWA") {
                    acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: 'FWA Plan', specifications: [] }))
                    if (Array.isArray(eshop_item.Products)) {
                        eshop_item.Products.forEach(product => {
                            acc.push(eshopItem({...product, ServiceType: product.ServiceType || 'FWA'}, { UUID: product.UUID }))
                        })
                    }
                }
                // Handle Mobile items
                else if (eshop_item.Products?.[0] && eshop_item.Products?.[1]) { //has device
                    acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: `SIM Card ${ (acc.length / 2) + 1 }`, specifications }))
                    acc.push(eshopItem(eshop_item.Products[0], { UUID: eshop_item.Products[0].UUID }))
                    acc.push(eshopItem(eshop_item.Products[1], { UUID: eshop_item.Products[1].UUID }))

                } else if (eshop_item.Products?.[0]) { //sim+plan
                    acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: `SIM Card ${ (acc.length / 2) + 1 }`, specifications }))
                    acc.push(eshopItem(eshop_item.Products[0], { UUID: eshop_item.Products[0].UUID }))
                } else { //sim only
                    acc.push(eshopItem(eshop_item, { UUID: eshop_item.UUID, name_counted: 'SIM Card', specifications }))
                }
                return acc
            }, [])
        },
        eshop_v2_cart_items_count: (state, getters) => getters.eshop_v2_cart_items.length,

        eshop_v2_cart_total: state => ((state.eshop_v2_cart?.AmountCents || 0) + (state.eshop_v2_cart?.AmountTaxCents || 0)) / 100,

        eshop_v2_cart_total_tax: state => (state.eshop_v2_cart?.AmountTaxCents || 0) / 100,

        eshop_v2_cart_due_now: state => (state.eshop_v2_cart?.AmountDueNowCents || 0) / 100,

        eshop_v2_cart_due_now_tax: state => (state.eshop_v2_cart?.AmountDueNowTaxCents || 0) / 100,

        eshop_v2_cart_items_quantity: (state, getters) => getters.eshop_v2_cart_items.reduce((quantity, item) => quantity+= item?.quantity || 0, 0),

        eshop_v2_purchased: state => state.eshop_v2_purchased,

        eshop_v2_has_e_sim: state => state.eshop_v2_cart.Items?.findIndex(item =>
            item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID
        ) > -1,
        eshop_v2_has_only_e_sims: state => state.eshop_v2_cart.Items?.length && state.eshop_v2_cart.Items?.every(item =>
            item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID
        ),
        eshop_v2_has_real_sim: state => state.eshop_v2_cart.Items?.findIndex(item => item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.real_sim.UUID) > -1,

        eshop_v2_checkout_flows: state => state.eshop_v2_checkout_flows,

        eshop_v2_with_input_delivery_instructions: () => process.env.VUE_APP_INPUT_DELIVERY_INSTRUCTIONS == 'true',
        eshop_v2_with_input_delivery_contact_number: () => process.env.VUE_APP_INPUT_DELIVERY_CONTACT_NUMBER == 'true',
        eshop_v2_sims_to_port: (state, getters) =>  {
            return getters.eshop_v2_cart_sims
                .map((sim, index) => {
                    return {
                        ...sim,
                        sim_counted_name: `SIM_Card ${index + 1}`
                    }
                })
                .filter(sim => (sim.Attributes?.PortingOverMSISDN || sim.Attributes?.PreSelectedMSISDN))
                .map(sim_to_port => {
                    const eshop_v2_cart_uuid = getters.eshop_v2_cart_uuid
                    const UUID = sim_to_port.UUID

                    const SIMS_PORTING_TYPES = dynStorage.get('SIMS_PORTING_TYPES', true)

                    const SIM_PORTING_TYPE = SIMS_PORTING_TYPES?.[`${eshop_v2_cart_uuid}--${UUID}`] || ''


                    const product_name = sim_to_port.Products?.[0]?.Name || ''

                    const last_index_of_opening_brackets = product_name.lastIndexOf('(')

                    const pre_selected_product_type = last_index_of_opening_brackets > -1 ? product_name.slice(last_index_of_opening_brackets) : ''

                    return {
                        sim_name: sim_to_port.sim_counted_name,
                        existing_phone_number: sim_to_port.Attributes?.PortingOverMSISDN || sim_to_port.Attributes?.PreSelectedMSISDN,
                        existing_phone_type: sim_to_port.Attributes?.PortingOverMSISDNType || SIM_PORTING_TYPE || pre_selected_product_type,
                        UUID: sim_to_port.UUID,
                        local_storage_sims_porting_types_key: `${getters.eshop_v2_cart_uuid}--${ sim_to_port.UUID}`,
                        is_preselected_phone_number: Boolean(sim_to_port.Attributes?.PreSelectedMSISDN)
                    }
                })
        },

        //eshop_v2_has_postpay_product: (state, getters) => getters.eshop_v2_cart_items?.some(item => item.product?.name?.endsWith('(Postpay)')),
        eshop_v2_has_postpay_product: (state, getters) => { //TODO: check if this is correct
            return getters.eshop_v2_cart_items?.some(item => {
                if (item && item.product) {
                    return item.product.name?.endsWith('(Postpay)');
                }
                return false;
            });
        },

        isV3Order: state => state.isV3Order,

        eshop_v2_has_v3_product: (state, getters) => {
            return getters.eshop_v2_cart_items?.some(item => {
                if (item && item.product && item.product.item) {
                    return item.product.item.ServiceType === 'FWA' || 
                           item.product.item.ServiceType === 'MOBILE';
                }
                return false;
            });
        },

        /*FWA getters */

        isFWAOrder: state => state.isFWAOrder,

        eshop_v2_has_fwa_product: (state, getters) => {
            return getters.eshop_v2_cart_items?.some(item => {
                if (item && item.product && item.product.item) {
                    return item.product.item.ServiceType == 'FWA';
                }
                return false;
            });
        },

        eshop_v2_has_ufb_product: (state, getters) => {
            return getters.eshop_v2_cart_items?.some(item => {
                if (item && item.product && item.product.item) {
                    return item.product.item.ServiceType == 'UFB';
                }
                return false;
            });
        },

        eshop_v2_fwa_address: (state, getters) => {
            return state.eshop_v2_cart.Address || null
        },


        eshop_v2_cart_FWA_products_total: (state, getters) => {
            let price = 0
            const eshop_v2_cart_items = getters.eshop_v2_cart_items
    
        
            for (let i = 0, len = eshop_v2_cart_items.length; i < len; i++) {
                const item = eshop_v2_cart_items[i]
                if (item && item.product && item.product.item) {
                    const productItem = item.product.item
                    
                    const isUpfrontProduct = (
                        (item.type === 'sim' || item.type === 'esim') ||
                        (item.type === 'modem' ||
                         (productItem.Type === 'TYPE_PRODUCT' && productItem.PhysicalType === 'MODEM'))
                    )

                    if (isUpfrontProduct) {
                        price += item.discount ? item.discount : item.price
                    }
                }
            }
            
            return price
        },

        /*UFB getters */

        eshop_v2_cart_UFB_products_total: (state, getters) => {
            let price = 0
            const eshop_v2_cart_items = getters.eshop_v2_cart_items
    
        
            for (let i = 0, len = eshop_v2_cart_items.length; i < len; i++) {
                const item = eshop_v2_cart_items[i]
                if (item && item.product && item.product.item) {
                    const productItem = item.product.item
                    
                    const isUpfrontProduct = (
                        productItem.ServiceType === 'UFB' &&
                        (item.type === 'modem' ||
                         (productItem.Type === 'TYPE_PRODUCT' && productItem.PhysicalType === 'MODEM'))
                    )

                    if (isUpfrontProduct) {
                        price += item.discount ? item.discount : item.price
                    }
                }
            }
            
            return price
        },

        eshop_v2_cart_ufb_items: state => state.eshop_v2_cart.Items?.filter(item => item.ServiceType === "UFB") || [],

        isUFBOrder: state => state.isUFBOrder,

        /* ---- Travel eSIM order (isolated from local mobile flow) ---- */

        isTravelOrder: state => state.isTravelOrder,

        // Flatten the travel cart into display rows WITHOUT touching the shared
        // eshopItem/all_services logic. Each SIM item yields a SIM row followed
        // by one row per plan product (a travel eSIM can have multiple plans).
        eshop_v2_travel_cart_items: state => {
            const items = state.eshop_v2_cart.Items
            if (!Array.isArray(items) || !items.length) return []

            const rows = []

            items.forEach((sim, sim_index) => {
                rows.push({
                    id: sim.UUID || `travel-sim-${sim_index}`,
                    uuid: sim.UUID,
                    type: 'esim',
                    name: sim.Name || 'eSIM',
                    name_counted: `SIM ${ sim_index + 1 }`,
                    requested_for_name: sim.Attributes?.RequestedForName || '',
                    price: (sim.PriceCents || 0) / 100,
                    is_sim: true,
                    item: sim,
                })

                const plans = Array.isArray(sim.Products)
                    ? sim.Products.filter(p => p.VirtualType === 'VT_PLAN')
                    : []

                plans.forEach(plan => {
                    rows.push({
                        id: plan.UUID || plan.Identifier,
                        uuid: plan.UUID,
                        type: 'plan',
                        name: plan.Name,
                        description: plan.Description,
                        price: (plan.PriceCents || 0) / 100,
                        is_sim: false,
                        item: plan,
                    })
                })
            })

            return rows
        },

        // "Total" — sum of everything in the travel cart (SIMs + all plans).
        eshop_v2_travel_cart_total: (state, getters) =>
            getters.eshop_v2_travel_cart_items.reduce((sum, row) => sum + (row.price || 0), 0),

        // "Total due now" — trust the BE-computed amount when present.
        eshop_v2_travel_cart_due_now: (state, getters) => {
            if (state.eshop_v2_cart && state.eshop_v2_cart.AmountDueNowCents != undefined) {
                return state.eshop_v2_cart.AmountDueNowCents / 100
            }
            return getters.eshop_v2_travel_cart_total
        },

        eshop_v2_has_ufb_deliverable_modem: (state, getters) => {
            return getters.eshop_v2_cart_items?.some(item => {
                if (item && item.product && item.product.item) {
                    const productItem = item.product.item
                    return (
                        productItem.ServiceType === 'UFB' && 
                        (item.type === 'ufb-modem' || 
                        (productItem.Type === 'TYPE_PRODUCT' && productItem.PhysicalType === 'MODEM'))
                    )
                }
                return false
            })
        },

        eshop_v2_ufb_address: (state, getters) => {
            return state.eshop_v2_cart.Address || null
        },
    },

    mutations: {
        eshopCartSet_v2(state, eshop_cart) {

            const isFWA = eshop_cart?.Items?.some(item => item.ServiceType === "FWA");
            const isUFB = eshop_cart?.Items?.some(item => item.ServiceType === "UFB");

            const isV3Order = eshop_cart?.Items?.some(item =>
                item.ServiceType === "FWA" || item.ServiceType === "MOBILE" || item.ServiceType === "UFB"
            );

            const isTravel = eshop_cart?.Items?.some(item =>
                item.ServiceType === "MOBILE"
                && (
                    item.ItemVariantUUID === TRAVEL_ESIM_ITEM_VARIANT_UUID
                    || (Array.isArray(item.Products) && item.Products.filter(p => p.VirtualType === "VT_PLAN").length > 1)
                )
            );

            state.isFWAOrder = isFWA;
            state.isUFBOrder = isUFB;
            state.isV3Order = isV3Order;
            state.isTravelOrder = Boolean(isTravel);

            state.eshop_v2_cart = eshop_cart

            if (eshop_cart.CustomerUUID || !eshop_cart.UUID) {
                dynStorage.remove(ESHOP_V2_CART)
            } else {
                dynStorage.set(ESHOP_V2_CART, eshop_cart.UUID, false, true)
            }
        },

        eshopSetTravelOrder_v2(state, is_travel) {
            state.isTravelOrder = Boolean(is_travel)
        },

        eshopCartLoading_v2(state, loading) {
            state.eshop_v2_cart_loading = loading
        },

        eshopCartReset_v2(state, force) {
            if (!state.eshop_v2_cart.UUID || force) {
                state.eshop_v2_cart = {}
                state.isUFBOrder = false
                state.isFWAOrder = false
                state.isV3Order = false
            }
        },



        eshopPurchasedSave_v2(state, { payload, location, is_only_sim }) {
            const e_sim = payload.Items.findIndex(item =>
                item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID
                || item.ItemVariantUUID === TRAVEL_ESIM_ITEM_VARIANT_UUID
            ) > -1
            const real_sim = payload.Items.findIndex(item => item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.real_sim.UUID) > -1

            let eshop_v2_purchased = {
                e_sim,
                number: payload.Number,
            }

            /**
             * @todo сделать проверку на наличие "физических" товаров в корзине,
             *       когда они появятся
             */
            if (real_sim) {
                eshop_v2_purchased.address = location?.Description
                eshop_v2_purchased.is_only_sim = is_only_sim
            }

            state.eshop_v2_purchased = eshop_v2_purchased
            dynStorage.set(ESHOP_V2_CART, payload.UUID, false, true)
            dynStorage.set(ESHOP_V2_PURCHASED, eshop_v2_purchased, false, true)
        },

        eshopPurchasedLoad_v2(state) {
            state.eshop_v2_purchased = dynStorage.get(ESHOP_V2_PURCHASED, true)
        },

        eshopPurchasedReset_v2(state) {
            state.eshop_v2_purchased = null

            dynStorage.remove(ESHOP_V2_PURCHASED)
        },



        eshopCheckoutFlowSave_v2(state, flow) {
            Vue.set(state.eshop_v2_checkout_flows, flow.id, flow)
            dynStorage.set(ESHOP_V2_CHECKOUT_FLOW, state.eshop_v2_checkout_flows, false, true)
        },
        eshopCheckoutFlowReset_v2(state, flow_id) {
            Vue.delete(state.eshop_v2_checkout_flows, flow_id)

            if (Object.keys(state.eshop_v2_checkout_flows).length) {
                dynStorage.set(ESHOP_V2_CHECKOUT_FLOW, state.eshop_v2_checkout_flows, false, true)
            } else {
                dynStorage.remove(ESHOP_V2_CHECKOUT_FLOW)
            }
        },

        eshopCheckoutFlowsLoad_v2(state) {
            state.eshop_v2_checkout_flows = dynStorage.get(ESHOP_V2_CHECKOUT_FLOW, true) || {}
        },
        eshopCheckoutFlowsReset_v2(state) {
            state.eshop_v2_checkout_flows = {}
            dynStorage.remove(ESHOP_V2_CHECKOUT_FLOW)
        },

        /*FWA mutations */
        eshopFWACartReset_v2(state, force) {
            if (!state.eshop_v2_cart.UUID || force) {
                state.eshop_v2_cart = {
                    sims: [],
                }
                state.isUFBOrder = false
                state.isFWAOrder = false
                state.isV3Order = false
            }
        },

        eshopFWAPurchasedSave_v2(state, { payload, location }) {
            const e_sim = payload.Items.findIndex(item => item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID) > -1
            const real_sim = payload.Items.findIndex(item => item.ItemUUID == AVAILABLE_SIM_TYPE_PRODUCTS.real_sim.UUID) > -1

            let eshop_v2_purchased = {
                e_sim,
                number: payload.Number,
            }

            /**
             * @todo add a check for the presence of "physical" items in the cart,
             *       when they appear
             */
            if (real_sim) {
                eshop_v2_purchased.address = location?.Formatted
                eshop_v2_purchased.is_only_sim = false
            }

            state.eshop_v2_purchased = eshop_v2_purchased

            dynStorage.set(ESHOP_V2_PURCHASED, eshop_v2_purchased, false, true)
        },

        /*UFB mutations */

        eshopUFBCartReset_v2(state, force) {
            if (!state.eshop_v2_cart.UUID || force) {
                state.eshop_v2_cart = {
                    Items: [],
                }
                state.isUFBOrder = false
                state.isFWAOrder = false
                state.isV3Order = false
            }
        },

        eshopUFBPurchasedSave_v2(state, { payload, result, location, broadband_flow }) {
            const orderData = result || payload;
            const itemsData = payload;

            const hasDeliverableModem = itemsData?.Items?.some(item =>
                item.ServiceType === 'UFB' &&
                item.Products?.some(product =>
                    product.Type === 'TYPE_PRODUCT' && product.PhysicalType === 'MODEM'
                )
            );

            let eshop_v2_purchased = {
                number: orderData.Number || payload.Number,
                ufb_modem: hasDeliverableModem,
            }

            if (hasDeliverableModem && location) {
                eshop_v2_purchased.address = location.Formatted
                eshop_v2_purchased.is_only_modem = itemsData?.Items?.length === 1 && hasDeliverableModem

                if (broadband_flow?.delivery?.address) {
                    eshop_v2_purchased.delivery_address = broadband_flow.delivery.address
                }
            }

            state.eshop_v2_purchased = eshop_v2_purchased
            dynStorage.set(ESHOP_V2_PURCHASED, eshop_v2_purchased, false, true)
        },

        // Move House cart mutations (separate from purchase cart)
        eshopMoveHouseCartSave(state, cart) {
            state.eshop_v2_move_house_cart = cart
        },

        eshopMoveHouseCartReset(state) {
            state.eshop_v2_move_house_cart = {}
        },
    },

    actions: {
        eshopCartLoad_v2({getters, commit, dispatch, state}) {
            // Skip cart restore if a UFB/FWA order is already in progress
            // to prevent overwriting the broadband cart built during checkout
            if (state.isUFBOrder || state.isFWAOrder) {
                return Promise.resolve(getters.eshop_v2_cart)
            }

            commit('eshopCartLoading_v2', true)
            let cart_uuid = dynStorage.get(ESHOP_V2_CART, true)

            if (cart_uuid == "undefined") {
                cart_uuid = null

                dynStorage.remove(ESHOP_V2_CART)
            }

            return dispatch('GetCatalogServices').then(() =>
                // PRIORITY: If customer is logged in, ALWAYS load customer's cart first
                // This ensures we get POI data with CustomerVerificationStatus
                (getters.current_account_uid
                    ? dispatch('eshopCartRestoreByCustomer_v2')
                    : cart_uuid
                        ? dispatch('eshopCartRestoreByUUID_v2', cart_uuid)
                        : Promise.resolve(getters.eshop_v2_cart)
                ).finally(() => {
                    commit('eshopCartLoading_v2', false)
                })
            )
        },

        eshopCartSaveSIMs_v2({getters, commit, dispatch}, sims) {
            if (!sims) {
                const getters_eshop_v2_cart_sims_modified = [...getters.eshop_v2_cart_sims]

                getters_eshop_v2_cart_sims_modified.forEach(cart_sim => {
                    const cart_sim_item_product_catalog_uuid = cart_sim.Products?.[0]?.Attributes?.MobileProductCatalogUUID
                    const cart_sim_item_product_availability_uuid = cart_sim.Products?.[0]?.Attributes?.MobileProductAvailabilityUUID

                    const cart_sim_plan_product = cart_sim_item_product_catalog_uuid && cart_sim_item_product_availability_uuid
                        ? getters.all_services.find(item =>
                            item.UUID == cart_sim_item_product_catalog_uuid
                            && item.Availabilities?.[0]?.UUID == cart_sim_item_product_availability_uuid
                        )
                        : null

                    const cart_sim_plan_product_retailCents = cart_sim_plan_product?.Availabilities?.[0]?.RetailCents

                    if (cart_sim_plan_product_retailCents != undefined) {
                        cart_sim.Products[0].PriceCents = cart_sim_plan_product_retailCents
                    }
                })

                sims = getters_eshop_v2_cart_sims_modified
            }

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,

                Items: sims.map(eshop_item => eshopCartItemSim_v2(eshop_item)),
            }

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)

                if (result?.Items) {
                    const value = ((result.AmountCents || 0) + (result.AmountTaxCents || 0)) / 100

                    dispatch('logAnalyticsEventAddToCart', { parameters: {
                        currency: "NZD",
                        value,
                        items: logAnalyticsItems(result?.Items),
                    }})
                }

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        eshopCartSaveSIMsMultiPlans_v2({getters, dispatch}, { sims_multi_plans, is_mobile_group_sim_order = false } = {}) {
            return dispatch('GetCatalogServices').then(() => {
                try {
                    const sims = []

                    for (let i = 0, len = sims_multi_plans.length; i < len; i++) {
                        const product_catalog_uuid = sims_multi_plans[i]?.Product?.MobileProductCatalogUUID
                        const product_availability_uuid = sims_multi_plans[i]?.Product?.MobileProductAvailabilityUUID

                        if (product_catalog_uuid && product_availability_uuid) {
                            const product = getters.all_services.find(item =>
                                item.UUID == product_catalog_uuid
                                && item.Availabilities?.[0]?.UUID == product_availability_uuid
                            )

                            if (product) {
                                const sim = {...AVAILABLE_SIM_TYPE_PRODUCTS_BY_UUID[sims_multi_plans[i].ItemUUID]}

                                if (sim) {
                                    sim.SelfManaged = sims_multi_plans[i].SelfManaged
                                    sim.Grouped = sims_multi_plans[i].Grouped
                                    sim.GroupMemberName = sims_multi_plans[i].GroupMemberName
                                    sim.UseMasterBillingAccount = sims_multi_plans[i].UseMasterBillingAccount
                                    sim.MobileGroupOwnerMobileUUID = sims_multi_plans[i].MobileGroupOwnerMobileUUID
                                    sim.BecomeGroupOwner = sims_multi_plans[i].BecomeGroupOwner

                                    const plan = {
                                        ...product,
                                        ProductType: sims_multi_plans[i].Product.ProductType,
                                        is_payg: sims_multi_plans[i].Product.is_payg,
                                        is_autoRenew: sims_multi_plans[i].Product.is_autoRenew,
                                    }

                                    sims.push(eshopCartItemSim_v2(null, sim, plan))
                                } else {
                                    throw new Error(`SIM ${ i+1 } type is not available`)
                                }
                            } else {
                                throw new Error(`SIM ${ i+1 } plan is not available`)
                            }
                        } else {
                            throw new Error(`SIM ${ i+1 } plan is not specified`)
                        }
                    }

                    return dispatch('eshopCartSaveSIMs_v2', eshopCartItemsMultiPlansSelfManaged_v2({ items: sims, is_mobile_group_sim_order }))
                } catch (error) {
                    return Promise.reject(error)
                }
            })
        },

        eshopCartAddSIM_v2({getters, dispatch}, { type, plan, empty, replacement_sim_options }) {
            if (type in AVAILABLE_SIM_TYPE_PRODUCTS) {
                const sims = getters.eshop_v2_cart_sims

                sims.push(eshopCartItemSim_v2(null, AVAILABLE_SIM_TYPE_PRODUCTS[type], plan?.product))

                if (empty) {
                    sims.push(eshopCartItemSim_v2(null, AVAILABLE_SIM_TYPE_PRODUCTS[type], null))
                }

                const is_only_sim = sims.length == 1 && sims[0]?.Products.length == 0

                if (replacement_sim_options &&  is_only_sim) {
                    const eshop_item = sims[0]

                    eshop_item.Attributes = {
                        ...(eshop_item.Attributes && eshop_item.Attributes),
                        SetupMobileGroup: replacement_sim_options.setup_mobile_group,
                        RequestedForName: replacement_sim_options.name,
                        SetupBillRouting: Boolean(replacement_sim_options.billing_child_route_uuid),
                        ReplacesMobileUUID: replacement_sim_options.mobile_product_uuid,
                    }
                }

                return dispatch('eshopCartSaveSIMs_v2', sims)
            } else {
                return Promise.reject('Unknown SIM type')
            }
        },

        async eshopCartSetSIMPlan_v2({getters, dispatch}, { type, plan, sim_uuid }) {
            if (type in AVAILABLE_SIM_TYPE_PRODUCTS) {
                if (plan?.product?.Availabilities
                    && Array.isArray(plan.product.Availabilities)
                    && plan.product.Availabilities.length
                ) {
                    const sims = getters.eshop_v2_cart_sims

                    const has_only_sim_in_sims = Boolean(sims.length) && !sims[0]?.Products.length

                    if (has_only_sim_in_sims) {
                        try {
                            await dispatch('eshopCartRemoveAllSIMs_v2')
                        } catch (error) {
                            return Promise.reject(error)
                        }
                    }

                    if (sim_uuid && sims.length) {
                        let is_changed = false

                        const updateSIMPlan = (sim) => {
                            if (sim
                                && (sim.Products[0]?.ProductCatalogUUID != plan.product.UUID
                                    || sim.Products[0]?.Attributes?.AutoRenew != plan.product.is_autoRenew
                                )
                            ) {
                                is_changed = true

                                sim.Products = [
                                    eshopCartItemProduct_v2(null, plan.product)
                                ]
                            }
                        }

                        if (sim_uuid == 'all') {
                            for (let i = 0, len = sims.length; i < len; i++) {
                                updateSIMPlan(sims[i])
                            }
                        } else {
                            const index = sims.findIndex(sim => sim.UUID == sim_uuid)

                            if (index > -1) {
                                updateSIMPlan(sims[index])
                            }
                        }

                        if (is_changed) {
                            return dispatch('eshopCartSaveSIMs_v2', sims)
                        } else {
                            return Promise.resolve(sims)
                        }
                    } else {
                        return dispatch('eshopCartAddSIM_v2', { type, plan })
                    }
                } else {
                    return Promise.reject(`Plan not specified`)
                }
            } else {
                return Promise.reject('Unknown SIM type')
            }
        },

        eshopCartRemoveSIM_v2({getters, dispatch}, uuid) {
            const sims = [...getters.eshop_v2_cart_sims]
            const index = sims.findIndex(sim => sim.UUID == uuid)

            if (index > -1) {
                sims.splice(index, 1)

                return dispatch('eshopCartSaveSIMs_v2', sims)
            } else {
                return Promise.resolve(uuid)
            }
        },

        eshopCartRemoveAllSIMs_v2({dispatch}) {
            return dispatch('eshopCartSaveSIMs_v2', [])
        },

        // Remove ONE travel eSIM (by UUID) and re-save the remaining SIMs,
        // preserving every plan per SIM. Isolated from eshopCartRemoveSIM_v2,
        // which rebuilds via eshopCartItemSim_v2 and would drop Products[1+].
        eshopCartRemoveTravelSIM_v2({getters, commit}, uuid) {
            const remaining = getters.eshop_v2_cart_sims.filter(sim => sim.UUID !== uuid)

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,

                Items: remaining.map(eshopCartItemTravelSim_v2),
            }

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)
                commit('eshopSetTravelOrder_v2', true)

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        // Save travel eSIM order to the cart. Unlike the local mobile flow, a
        // single travel eSIM can carry MULTIPLE plans (one per destination), so
        // each SIM item gets multiple Products. Built directly (travelMobileAddon
        // plans aren't in the mobile `all_services` catalog) and POSTed as-is —
        // BE will validate the multi-plan-per-SIM structure.
        eshopCartSaveTravelSims_v2({getters, commit}, travel_sims) {
            const Items = (travel_sims || []).map(sim => {
                const item = {
                    UUID: null,
                    PriceCents: 0, // SIM price assigned by BE
                    Name: 'eSIM',
                    Type: 'TYPE_VIRTUAL',
                    VirtualType: 'VT_ESIM',
                    ItemUUID: AVAILABLE_SIM_TYPE_PRODUCTS.e_sim.UUID,
                    ItemVariantUUID: TRAVEL_ESIM_ITEM_VARIANT_UUID,
                    SelfManaged: true,
                    ServiceType: 'MOBILE',
                    Attributes: {
                        RequestedForName: sim.name || '',
                        CustomerCreation: getters.is_account
                            ? (process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer')
                            : 'BrandNewCustomer',
                    },
                    // Multiple plan products under one eSIM (one per destination)
                    Products: (sim.plans || []).map(plan => eshopCartItemProduct_v2(null, plan)),
                }

                item.Description = item.Name

                return item
            })

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,

                Items,
            }

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)
                // Explicitly mark as a travel order (covers single-plan travel
                // orders that content-detection wouldn't catch).
                commit('eshopSetTravelOrder_v2', true)

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        // Re-save the CURRENT travel cart (e.g. after registration) preserving
        // ALL plan products per SIM. Isolated from the local eshopCartSaveSIMs_v2
        // path, which rebuilds via eshopCartItemSim_v2 and drops Products[1+].
        // Rebuilds each SIM item straight from the existing cart data + CustomerUUID.
        eshopCartAddCustomerToTravelCart_v2({getters, commit}) {
            const customerCreation = process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer'
            const Items = getters.eshop_v2_cart_sims.map(sim => {
                const item = eshopCartItemTravelSim_v2(sim)
                item.Attributes.CustomerCreation = customerCreation
                return item
            })

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,

                Items,
            }

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)
                commit('eshopSetTravelOrder_v2', true)

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        eshopCartRestoreByUUID_v2({getters, commit, dispatch}, uuid) {
            return axiosIntents.get(`/eshop/v3/cart/${ uuid }`).then(({result}) => {
                // Pass isRestored: true to prevent double API call
                dispatch('handleV3Order', { eshop_cart: result, isRestored: true })

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        eshopCartRestoreByCustomer_v2({getters, commit, dispatch}) {
            const uuid = getters.current_account_uid

            return axiosIntents.get('/eshop/v3/customer/:uuid/cart').then(({result}) => {
                console.log('eshopCartRestoreByCustomer_v2', result)
                // DEBUG: Log POI data from customer cart
                console.log('[CART RESTORE] eshopCartRestoreByCustomer_v2 - POI data:', result.POI);

                if (uuid == getters.current_account_uid) {
                    // Pass isRestored: true to prevent double API call
                    dispatch('handleV3Order', { eshop_cart: result, isRestored: true })
                }

                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        eshopPurchase_v2({getters, commit, dispatch}, { location, is_only_sim, payment, delivery_instructions, delivery_contact_number, PaymentOptions }) {
            const sims = getters.eshop_v2_cart_sims
            const local_storage_sims_porting_types_keys = getters.eshop_v2_sims_to_port.map(sim_to_port => sim_to_port.local_storage_sims_porting_types_key)
            const auth_user_profile_creds = getters.auth_user_profile_creds
            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,

                Address: {
                    ...toApiAddress(location),
                    Email: auth_user_profile_creds.email,
                    Name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
                    Notes: delivery_instructions,
                    Phone: getters.eshop_v2_with_input_delivery_contact_number
                        ? delivery_contact_number
                        : auth_user_profile_creds.phone,
                },

                // Travel orders preserve every plan per SIM; local orders use the
                // standard single-plan rebuild.
                Items: getters.isTravelOrder
                    ? sims.map(eshopCartItemTravelSim_v2)
                    : sims.map(eshop_item => eshopCartItemSim_v2(eshop_item)),
                ...(PaymentOptions && { PaymentOptions }),
            }
            const checkout_card = () => axiosIntents.post('/eshop/v3/checkout', payload).then(({result}) => {
                 commit('eshopPurchasedSave_v2', { payload, location, is_only_sim });
                if (getters.is_checkout_payment_confirmation && result?.ClientSecret) {

                    const srtripe_client_secret = result.ClientSecret

                    return dispatch('stripePaymentConfirmation', {
                        card_token: payment?.cardId || getters.defaultPaymentCardId,
                        client_secret: srtripe_client_secret,
                    }).catch(error => {
                        return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location, is_only_sim } })
                    })
                }

                return Promise.resolve(result)
            }).catch( error => {
                console.error('eshopPurchase_v2 error', error)
                return Promise.reject(error)
            });
            const checkout_BNPL = () => axiosIntents.post('/eshop/v3/checkout', payload).then(({result}) => {
                if (getters.is_checkout_payment_confirmation && result?.ClientSecret) {
                    // Save purchase data before redirecting to Afterpay
                    commit('eshopPurchasedSave_v2', { payload, location, is_only_sim });

                    const srtripe_client_secret = result.ClientSecret

                    // For Afterpay payments
                    return dispatch('stripePaymentConfirmationAfterpayClearpay', {
                        client_secret: srtripe_client_secret,
                        return_url: window.location.origin + '/eshop/bnpl-return',
                        checkout_url: window.location.origin + '/eshop/checkout'
                    }).then(response => {
                        // This code will only run if the redirect doesn't happen
                        // which typically means there was an error
                        console.log('Afterpay payment response:', response);
                        return Promise.resolve(response);
                    }).catch(error => {
                        console.error('Afterpay payment error:', error);
                        // Only redirect here if there was an error initializing Stripe
                        // Don't redirect if confirmAfterpayClearpayPayment is successful
                        // as it will handle the redirect itself
                        return Promise.reject({
                            ...error,
                            srtripe_client_secret,
                            eshopPurchasedSave_data: { payload, location, is_only_sim }
                        });
                    })
                }

                return Promise.resolve(result)
            }).catch(error => {
                console.error('Afterpay checkout API error:', error)
                return Promise.reject(error)
            });
            const checkout_Klarna = () => axiosIntents.post('/eshop/v3/checkout', payload).then(({result}) => {
                if (getters.is_checkout_payment_confirmation && result?.ClientSecret) {
                    // Save purchase data before redirecting to Klarna
                    // For Klarna payments
                    commit('eshopPurchasedSave_v2', { payload, location, is_only_sim });

                    const srtripe_client_secret = result.ClientSecret
                    const eshopPurchasedSave_data = { payload, location, is_only_sim };

                    return dispatch('stripePaymentConfirmationKlarna', {
                        card_token:{billing_details: {
                                name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
                                email: auth_user_profile_creds.email},},
                        client_secret: srtripe_client_secret,
                        return_url: window.location.origin + '/eshop/bnpl-return',
                        checkout_url: window.location.origin + '/eshop/checkout'
                    }).then(response => {
                        console.log('response:', response);
                        return Promise.resolve(response);
                    }).catch(error => {
                        
                        console.error('payment error:', error);
                        return Promise.reject({
                            ...error,
                            srtripe_client_secret,
                            eshopPurchasedSave_data: { payload, location, is_only_sim }
                        });
                    })
                }

                return Promise.resolve(result)
            }).catch(error => {
                console.error('Klarna checkout API error:', error)
                return Promise.reject(error)
            });
            const checkout = PaymentOptions?.PaymentMethodType === "afterpay" ? checkout_BNPL()
                             : PaymentOptions?.PaymentMethodType === "klarna" ? checkout_Klarna()
                             : checkout_card();
                    

            return checkout.then(result => {

                if (local_storage_sims_porting_types_keys.length) {
                    const SIMS_PORTING_TYPES = dynStorage.get('SIMS_PORTING_TYPES', true)
                    if (SIMS_PORTING_TYPES) {
                        local_storage_sims_porting_types_keys.forEach(key => {
                            delete SIMS_PORTING_TYPES[key]
                        })
                        dynStorage.set('SIMS_PORTING_TYPES', SIMS_PORTING_TYPES, false, true)
                    }
                }

                if (payload.Items.length) {
                    const items = logAnalyticsItems(payload.Items)
                    const value = items.reduce((value, item) => value+= (item.price || 0) * (item.quantity || 0), 0)
                    dispatch('logAnalyticsEventPurchase', { parameters: {
                        currency: "NZD",
                        value,
                        items,
                    }})
                }

                return Promise.resolve(result)
            })
        },

        eshopGetCustomerOrders_v2() { //TODO deprecated needs to be removed
            return axiosIntents.get('/eshop/v3/customer/:uuid/orders')
                .then(({result}) => Promise.resolve(result))
        },

        eshopGetCustomerOrder_v2({}, OrderNumber) { //TODO needs to be renamed to eshopGetCustomerOrder_v3 or even better eshopGetCustomerOrder
            return axiosIntents.get(`/eshop/v3/customer/:uuid/order/${OrderNumber}`)
                .then(({result}) => Promise.resolve(result))
        },

        eshopGetCustomerOrderItem_v2({ dispatch }, { OrderNumber, UUID }) { //TODO needs to be removed
            return dispatch('eshopGetCustomerOrder_v2', OrderNumber).then(({OrderItems, Status}) => {
                if (!OrderItems) return Promise.reject('No Order Items')

                const spreded_order_items = OrderItems.reduce((acc, orderItem) => {
                    const order_item_products = orderItem.Products || []

                    return [...acc, orderItem, ...order_item_products]
                }, [])

                const order_item = spreded_order_items.find(item => item.UUID == UUID)

                if (!order_item) return Promise.reject('No Order Item')

                return Promise.resolve({...order_item, Status})
            })
        },

        eshopCartAddPreSelectedMSISDNToSIM_v2({ getters, dispatch }, { UUID, PreSelectedMSISDN } = {}) {
            const sims = [...getters.eshop_v2_cart_sims]
            const index = sims.findIndex(sim => sim.UUID == UUID)

            if (index > -1) {
                sims[index] = {
                    ...sims[index],
                    Attributes: {
                        ...(sims[index].Attributes && sims[index].Attributes),
                        PreSelectedMSISDN,
                    }
                }

                return dispatch('eshopCartSaveSIMs_v2', sims)
            } else {
                return Promise.resolve(UUID)
            }
        },

        eshopCartRemovePreSelectedNumberFromSIM_v2({getters, dispatch}, UUID) {
            const sims = [...getters.eshop_v2_cart_sims]
            const index = sims.findIndex(sim => sim.UUID == UUID)

            if (index > -1) {
                const Attributes = {
                    ...(sims[index].Attributes && sims[index].Attributes)
                }

                Attributes.PreSelectedMSISDN = ''

                sims[index] = {
                    ...sims[index],
                    Attributes,
                }

                return dispatch('eshopCartSaveSIMs_v2', sims)
            } else {
                return Promise.resolve(UUID)
            }
        },

        eshopCartAddNumberPortingToSIM_v2({getters, dispatch}, {
            UUID,
            PortingAccountLSP,
            PortingCarrierLSP,
            PortingNametagLSP,
            PortingPriorSIMID,
            PortingOverMSISDN,
            PortingOverMSISDNType
        } = {}) {
            const sims = [...getters.eshop_v2_cart_sims]
            const index = sims.findIndex(sim => sim.UUID == UUID)

            if (index > -1) {
                const eshop_v2_cart_uuid = getters.eshop_v2_cart_uuid

                let SIMS_PORTING_TYPES = dynStorage.get('SIMS_PORTING_TYPES', true)

                if (SIMS_PORTING_TYPES) {
                    SIMS_PORTING_TYPES[`${eshop_v2_cart_uuid}--${UUID}`] = PortingOverMSISDNType
                } else {
                    SIMS_PORTING_TYPES = {}
                    SIMS_PORTING_TYPES[`${eshop_v2_cart_uuid}--${UUID}`] = PortingOverMSISDNType
                }

                dynStorage.set('SIMS_PORTING_TYPES', SIMS_PORTING_TYPES, false, true)
                sims[index] = {
                    ...sims[index],
                    Attributes: {
                        ...(sims[index].Attributes && sims[index].Attributes),
                        PortingAccountLSP,
                        PortingCarrierLSP,
                        PortingNametagLSP,
                        PortingPriorSIMID,
                        PortingOverMSISDN,
                        PortingOverMSISDNType,
                    }
                }

                return dispatch('eshopCartSaveSIMs_v2', sims)
            } else {
                return Promise.resolve(UUID)
            }
        },

        eshopCartRemoveNumberPortingFromSIM_v2({getters, dispatch}, UUID) {
            const sims = [...getters.eshop_v2_cart_sims]
            const index = sims.findIndex(sim => sim.UUID == UUID)

            if (index > -1) {
                const Attributes = {
                    ...(sims[index].Attributes && sims[index].Attributes)
                }

                Attributes.PortingAccountLSP = ''
                Attributes.PortingCarrierLSP = 0
                Attributes.PortingNametagLSP = ''
                Attributes.PortingPriorSIMID = ''
                Attributes.PortingOverMSISDN = ''
                Attributes.PortingOverMSISDNType = ''

                sims[index] = {
                    ...sims[index],
                    Attributes,
                }

                return dispatch('eshopCartSaveSIMs_v2', sims).then(saved_sims => {
                    const eshop_v2_cart_uuid = getters.eshop_v2_cart_uuid
                    const SIMS_PORTING_TYPES = dynStorage.get('SIMS_PORTING_TYPES', true)

                    if (SIMS_PORTING_TYPES) {
                        delete SIMS_PORTING_TYPES[`${eshop_v2_cart_uuid}--${UUID}`]

                        dynStorage.set('SIMS_PORTING_TYPES', SIMS_PORTING_TYPES, false, true)
                    }

                    return Promise.resolve(saved_sims)
                })
            } else {
                return Promise.resolve(UUID)
            }
        },

        /*fwa actions */
        async fwaCartAddSIM({getters, dispatch, commit, state}, {sim_type, plan, broadband_flow, broadband_device}) {

            if (sim_type in AVAILABLE_SIM_TYPE_PRODUCTS) {
                if (getters.eshop_v2_cart_sims.length) { //Reset SIM
                    commit('eshopFWACartReset_v2', true)
                }
                let sims = getters.eshop_v2_cart_sims
                sims.push(eshopFWACartItemSim_v2(null, null, AVAILABLE_SIM_TYPE_PRODUCTS[sim_type], plan, broadband_device, true))
                return dispatch('fwaCartSaveSIM', {sims, broadband_flow})
            } else {
                return Promise.reject('Unknown SIM type')
            }
        },

        fwaCartSaveSIM({getters, commit, dispatch}, {sims, broadband_flow}) {
            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,
                Address: toApiAddress(broadband_flow.location),
    
                Items: sims,
            }

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)
                if (result?.Items) {
                    const value = ((result.AmountCents || 0) + (result.AmountTaxCents || 0)) / 100
                    dispatch('logAnalyticsEventAddToCart', { parameters: {
                        currency: "NZD",
                        value,
                        items: logAnalyticsItems(result?.Items),
                    }})
                }
                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        async eshopFWAAddCustomerUUIDToCart({ getters, commit }, { broadband_flow }) {
            const customerUUID = getters.current_account_uid
            const cartItems = getters.eshop_v2_cart.Items || []
            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: customerUUID,
                Address: toApiAddress(broadband_flow.location),
                Items: cartItems.map(item => ({
                    ...item,
                    Attributes: {
                        ...item.Attributes,
                        CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
                        SetupMobileGroup: item.Attributes?.SetupMobileGroup ?? false,
                        SetupBillRouting: item.Attributes?.SetupBillRouting ?? false,
                    },
                    Products: item.Products?.map(product => ({
                        ...product,
                        Attributes: {
                            ...product.Attributes,
                            BillingReference: product.Attributes?.BillingReference ?? 'postpay',
                            AutoRenew: product.Attributes?.AutoRenew ?? true,
                        },
                        Quantity: product.Quantity ?? 1,
                        ServiceType: product.ServiceType ?? 'FWA',
                        VirtualType: product.VirtualType ?? 'VT_PLAN',
                        PhysicalType: product.PhysicalType ?? '',
                    })),
                })),
            }

            try {
                const result = await axiosIntents.post('/eshop/v3/cart', payload)
                commit('eshopCartSet_v2', result.result)
                return result.result
            } catch (error) {
                console.error('Failed to update cart with CustomerUUID:', error)
                throw error
            }
        },

        eshopPurchaseFWA({getters, commit, dispatch}, { address, payment, delivery_instructions, delivery_contact_number, PaymentOptions, contact }) {
            const sims = getters.eshop_v2_cart_fwa_sims.length ? getters.eshop_v2_cart_fwa_sims : getters.eshop_v2_cart_sims
            const is_only_sim = false
            const location = address
            const auth_user_profile_creds = getters.auth_user_profile_creds
            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,
                Address: {
                    ...toApiAddress(address),
                    Email: auth_user_profile_creds.email,
                    Name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
                    Notes: delivery_instructions,
                    Phone: getters.eshop_v2_with_input_delivery_contact_number
                        ? delivery_contact_number
                        : auth_user_profile_creds.phone,
                },
                Items: sims.map(eshop_item => eshopFWACartItemSim_v2(eshop_item, contact)),

                ...(PaymentOptions && { PaymentOptions }),
            }
            return axiosIntents.post('/eshop/v3/checkout', payload).then(({result}) => {
                if (getters.is_checkout_payment_confirmation && result?.ClientSecret) {
                    const srtripe_client_secret = result.ClientSecret

                    if(PaymentOptions?.PaymentMethodType == "afterpay"){
                        // Save purchase data before redirecting to Afterpay
                        commit('eshopFWAPurchasedSave_v2', { payload, location });

                        return dispatch('stripePaymentConfirmationAfterpayClearpay', {
                            card_token:{billing_details: {
                                name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
                                email: auth_user_profile_creds.email},},
                            client_secret: srtripe_client_secret,
                            return_url: window.location.origin + '/eshop/bnpl-return?broadband=true',
                            checkout_url: window.location.origin + '/eshop/checkout-fwa'
                        })
                        .then(() => {
                            commit('resetBroadbandFlow')
                            return Promise.resolve(result)
                        })
                        .catch(error => {
                            return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location, is_only_sim } })
                        })
                    }
                    else if(PaymentOptions?.PaymentMethodType == "klarna"){
                            // Save purchase data before redirecting to Afterpay
                            commit('eshopFWAPurchasedSave_v2', { payload, location });
    
                            return dispatch('stripePaymentConfirmationKlarna', {
                                card_token:{billing_details: {
                                    name: [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim(),
                                    email: auth_user_profile_creds.email},},
                                    client_secret: srtripe_client_secret,
                               
                                // Explicitly include broadband=true in the return URL
                                 return_url: window.location.origin + '/eshop/bnpl-return?broadband=true',
                                 checkout_url: window.location.origin + '/eshop/checkout-fwa'
                            })
                            .then(() => {
                                commit('resetBroadbandFlow')
                                return Promise.resolve(result)
                            })
                            .catch(error => {
                                return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location, is_only_sim } })
                            })
                        }
                    else{
                    return dispatch('stripePaymentConfirmation', {
                        card_token: payment?.cardId || getters.defaultPaymentCardId,
                        client_secret: srtripe_client_secret,
                    })
                    .then(() => {
                        commit('resetBroadbandFlow')

                    })
                    .catch(error => {
                        return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location, is_only_sim } })
                    })
                }
    
            }
            }).then(result => {
                commit('eshopFWACartReset_v2', true)
                if (PaymentOptions?.PaymentMethodType !== "afterpay") {
                    commit('eshopFWAPurchasedSave_v2', { payload, location });
                }
                dynStorage.remove(ESHOP_V2_CART)

                if (payload.Items.length) {
                    const items = logAnalyticsItems(payload.Items)
                    const value = items.reduce((value, item) => value+= (item.price || 0) * (item.quantity || 0), 0)

                    const analytics_parameters = {
                        parameters: {
                            currency: "NZD",
                            value,
                            items,
                        }
                    }

    
                    dispatch('logAnalyticsEventPurchase', analytics_parameters)
                }
    
                return Promise.resolve(result)
            })
        },

        eshopGetCustomerOrder_v3({}, OrderNumber) {
            return axiosIntents.get(`/eshop/v3/customer/:uuid/order/${OrderNumber}`)
                .then(({result}) => Promise.resolve(result))
        },

        eshopCartRemoveAllFWASIMs({dispatch}, {address} = {}) {
            return dispatch('fwaCartSaveSIM', {sim: [], broadband_flow: {location: address}})
        },

        eshopCartRestoreByCustomer_v3({ getters, commit, dispatch }) {
            const uuid = getters.current_account_uid;
        
            return axiosIntents.get('/eshop/v3/customer/:uuid/cart').then(({ result }) => {
                if (uuid == getters.current_account_uid) {
                    
                    const isV3Order = result?.Items?.some(item => 
                        item.ServiceType === "FWA" || item.ServiceType === "MOBILE" || 
                        item.ServiceType === "UFB"
                    );

                    if (isV3Order) {
                        // Handle FWA-specific logic without calling itself again
                        dispatch('handleV3Order', { eshop_cart: result, isRestored: true });
                    } else {
                        // Commit the cart directly if it's not an FWA order
                        commit('eshopCartSet_v2', result);
                    }
                }

                return Promise.resolve(getters.eshop_v2_cart);
            });
        },

        async handleV3Order({ commit }, { eshop_cart, isRestored = false }) {

            const isV3Order = eshop_cart?.Items?.some(item =>
                item.ServiceType === "FWA" || item.ServiceType === "MOBILE" ||
                item.ServiceType === "UFB"
            )

            if (isV3Order && !isRestored) {
                console.log('V3 order detected and not yet restored');
                try {
                    const restoredCart = await axiosIntents.get(`/eshop/v3/cart/${ eshop_cart.UUID }`).then(({ result }) => result);
                    console.log('Restored V3 cart:', restoredCart);
                    
                    commit('eshopCartSet_v2', restoredCart);
                } catch (error) {
                    console.error('Failed to restore V3Order cart:', error);
                }
            } else {
                commit('eshopCartSet_v2', eshop_cart);
            }
        },

        eshopGetCustomerOrders_v3() {
            return axiosIntents.get('/eshop/v3/customer/:uuid/orders')
                .then(({result}) => Promise.resolve(result))
        },

        /*UFB Actions*/

        async ufbCartAddPlan({getters, dispatch, commit, state}, {plan, broadband_flow, broadband_device}) {
            if (getters.eshop_v2_cart?.Items?.length) {
                commit('eshopUFBCartReset_v2', true)
            }

            const ufbItem = eshopUFBCartItemPlan_v2(null, plan, broadband_device, broadband_flow, true)
            if (!ufbItem) {
                return Promise.reject('Failed to create UFB cart item')
            }

            return dispatch('ufbCartSavePlan', {items: ufbItem, broadband_flow})
        },

        ufbCartSavePlan({getters, commit, dispatch}, {items, broadband_flow}) {

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,
                Address: {
                    City: broadband_flow.location?.City ?? '',
                    Country: broadband_flow.location?.Country ?? 'New Zealand',
                    PostCode: broadband_flow.location?.PostCode ?? broadband_flow.location?.Postcode ?? '',
                    Name: getters.auth_user_profile_creds?.first_name && getters.auth_user_profile_creds?.last_name
                        ? [getters.auth_user_profile_creds.first_name, getters.auth_user_profile_creds.last_name].join(' ').trim()
                        : '',
                    Lines: broadband_flow.location?.Lines ?? [''],
                },

                Items: items,
            }

            console.log('UFB payload:', payload);

            return axiosIntents.post('/eshop/v3/cart', payload).then(({result}) => {
                commit('eshopCartSet_v2', result)
                if (result?.Items) {
                    const value = ((result.AmountCents || 0) + (result.AmountTaxCents || 0)) / 100
                    dispatch('logAnalyticsEventAddToCart', { parameters: {
                        currency: "NZD",
                        value,
                        items: logAnalyticsItems(result?.Items),
                    }})
                }
                return Promise.resolve(getters.eshop_v2_cart)
            })
        },

        async eshopUFBAddCustomerUUIDToCart({ getters, dispatch, commit }, { broadband_flow }) {
            console.log('eshopUFBAddCustomerUUIDToCart', broadband_flow);

            const customerUUID = getters.current_account_uid
            const cartItems = getters.eshop_v2_cart.Items || []
            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: customerUUID,
                Address: {
                    City: broadband_flow.location?.City ?? '',
                    Country: broadband_flow.location?.Country ?? 'New Zealand',
                    PostCode: broadband_flow.location?.PostCode ?? broadband_flow.location?.Postcode ?? '',
                    Name: getters.auth_user_profile_creds?.first_name && getters.auth_user_profile_creds?.last_name
                        ? [getters.auth_user_profile_creds.first_name, getters.auth_user_profile_creds.last_name].join(' ').trim()
                        : '',
                    Lines: broadband_flow.location?.Lines ?? [''],
                },
                Items: cartItems.map(item => ({
                    ...item,
                    Attributes: {
                        ...item.Attributes,
                        CustomerCreation: process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
                        BillingReference: item.Attributes?.BillingReference ?? 'postpay',
                        AutoRenew: item.Attributes?.AutoRenew ?? true,

                        ...(item.Attributes?.UFBAttributes && {
                            UFBAttributes: {
                                ...item.Attributes.UFBAttributes,
                                PrequalUUID: broadband_flow?.serviceAvailability?.PrequalUUID || item.Attributes.UFBAttributes.PrequalUUID || null,
                                ServiceType: item.Attributes.UFBAttributes.ServiceType || "Managed",
                                OrderType: item.Attributes.UFBAttributes.OrderType || (() => {
                                    const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" :
                                        broadband_flow?.transfer?.required === false ? "MultiPrimary" :
                                        "ConnectPrimary";
                                    return orderType;
                                })(),
                                RSFDate: broadband_flow?.rsf?.StartTimeNanos 
                                    ? broadband_flow.rsf.StartTimeNanos 
                                    : Date.now() * 1000000
                            }
                        })
                    },
                    ServiceType: item.ServiceType === "UFB" ? "UFB" : item.ServiceType,
                    VirtualType: item.VirtualType ?? 'VT_PLAN',
                    PhysicalType: item.PhysicalType ?? '',
                })),
            };

            console.log('Updated UFB payload with CustomerUUID:', payload);

            return new Promise(async (resolve, reject) => {
                try {
                    const result = await axiosIntents.post('/eshop/v3/cart', payload);

                    commit('eshopCartSet_v2', result.result);
                    resolve(result.result);

                } catch (error) {
                    console.error('Failed to update UFB cart with CustomerUUID:', error);
                    reject(error);
                }
            });
        },

        async ufbCartRemoveAll({commit}) {
            commit('eshopUFBCartReset_v2', true)
            return Promise.resolve()
        },

        eshopPurchaseUFB({getters, commit, dispatch}, { payment, address, delivery_instructions, delivery_contact_number, PaymentOptions }) {
            const ufbItems = getters.eshop_v2_cart_ufb_items
            const location = address
            const auth_user_profile_creds = getters.auth_user_profile_creds
            const broadband_flow = getters.broadband_flow
            
            const contactName = [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim()
            const contactPhone = broadband_flow?.contact_phone || auth_user_profile_creds.phone
            
            const serviceAddress = address?.Formatted || 
                `${address?.Lines?.filter(line => line).join(', ')}, ${address?.City}, ${address?.Country}, ${address?.PostCode}`.replace(/^, /, '')
            
            const rsfDate = broadband_flow?.rsf?.StartTimeNanos
                ? broadband_flow.rsf.StartTimeNanos
                : Date.now() * 1000000  // Convert current time to nanoseconds

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_cart_uuid,
                Number: getters.eshop_v2_cart_number,
                CustomerUUID: getters.current_account_uid,
                Address: {
                    ...toApiAddress(address),
                    Email: auth_user_profile_creds.email,
                    Name: contactName,
                    ...(getters.eshop_v2_has_ufb_deliverable_modem && delivery_instructions && {
                        Notes: delivery_instructions
                    }),
                    ...(getters.eshop_v2_has_ufb_deliverable_modem && delivery_contact_number && {
                        Phone: delivery_contact_number
                    }),
                    ...(!getters.eshop_v2_has_ufb_deliverable_modem && {
                        Phone: auth_user_profile_creds.phone
                    })
                },
                Items: ufbItems.map(eshop_item => ({
                    ...eshop_item,
                    Attributes: {
                        ...eshop_item.Attributes,
                        UFBAttributes: {
                            ...eshop_item.Attributes?.UFBAttributes,
                            PrequalUUID: broadband_flow?.serviceAvailability?.PrequalUUID || eshop_item.Attributes?.UFBAttributes?.PrequalUUID || null,
                            ServiceType: "Managed",
                            OrderType: eshop_item.Attributes?.UFBAttributes?.OrderType || (() => {
                                const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" :
                                    broadband_flow?.transfer?.required === false ? "MultiPrimary" :
                                    "ConnectPrimary";
                                return orderType;
                            })(),
                            RSFDate: rsfDate,
                            ServiceAddress: serviceAddress,
                            TransferFrom: {
                                Provider: eshop_item.Attributes?.UFBAttributes?.TransferFrom?.Provider || "",
                                AccountHolderName: eshop_item.Attributes?.UFBAttributes?.TransferFrom?.AccountHolderName || "",
                                AccountNumber: eshop_item.Attributes?.UFBAttributes?.TransferFrom?.AccountNumber || "",
                                // If there are existing connections, pass the ConnectionID regardless of transfer type
                                ConnectionID: eshop_item.Attributes?.UFBAttributes?.TransferFrom?.ConnectionID ||
                                    (broadband_flow.transfer?.connection?.ID ? broadband_flow.transfer.connection.ID : "")
                            }
                        },
                        ESIMInfo: {
                            ID: "",
                            Data: "",
                            ConfirmationCode: ""
                        },
                        Contact: {
                            PhoneNumber: contactPhone,
                            Name: contactName
                        },
                        CustomerCreation: eshop_item.Attributes?.CustomerCreation || process.env.VUE_APP_ORDER_CUSTOMER_CREATION_WITH_SELF_MANAGE_TOGGLE_ON || 'ReuseTheCustomer',
                        BillingReference: eshop_item.Attributes?.BillingReference || "postpay",
                        AutoRenew: eshop_item.Attributes?.AutoRenew ?? true,
                        MobileProductAvailabilityUUID: eshop_item.Attributes?.MobileProductAvailabilityUUID,
                        MobileProductCatalogUUID: eshop_item.Attributes?.MobileProductCatalogUUID,
                        SetupBillRouting: false,
                        BillRouteCustomerUUID: "",
                        MobileGroupOwnerMobileUUID: "",
                        DesiredGroupType: "",
                        BecomeGroupOwner: false,
                        SetupMobileGroup: false,
                        RequestedForName: "",
                        PortingOverMSISDN: "",
                        PortingCarrierLSP: 0,
                        PortingAccountLSP: "",
                        PortingNametagLSP: "",
                        PortingPriorSIMID: "",
                        AddIdentityAccess: false,
                        PreSelectedMSISDN: "",
                        ReplacesMobileUUID: ""
                    },
                    ...(eshop_item.Products && {
                        Products: eshop_item.Products.map(product => ({
                            ...product,
                            Attributes: {
                                ...product.Attributes,
                                UFBAttributes: {
                                    ...product.Attributes?.UFBAttributes,
                                    PrequalUUID: broadband_flow?.serviceAvailability?.PrequalUUID || null,
                                    ServiceType: "Managed",
                                    OrderType: (() => {
                                        const orderType = broadband_flow?.transfer?.required === true ? "TransferPrimary" :
                                            broadband_flow?.transfer?.required === false ? "MultiPrimary" :
                                            "ConnectPrimary";
                                        return orderType;
                                    })(),
                                    RSFDate: rsfDate,
                                    ServiceAddress: serviceAddress,
                                    TransferFrom: {
                                        Provider: "",
                                        AccountHolderName: "",
                                        AccountNumber: "",
                                        // If there are existing connections, pass the ConnectionID regardless of transfer type
                                        ConnectionID: broadband_flow.transfer?.connection?.ID ? broadband_flow.transfer.connection.ID : ""
                                    }
                                }
                            }
                        }))
                    })
                })),
                ...(PaymentOptions && { PaymentOptions }),
            }

            return axiosIntents.post('/eshop/v3/checkout', payload).then(({result}) => {
                if (getters.is_checkout_payment_confirmation && result?.ClientSecret) {
                    const srtripe_client_secret = result.ClientSecret

                    if(PaymentOptions?.PaymentMethodType == "afterpay"){
                        commit('eshopUFBPurchasedSave_v2', {
                            payload,
                            result,
                            location,
                            broadband_flow: broadband_flow
                        });

                        return dispatch('stripePaymentConfirmationAfterpayClearpay', {
                            card_token:{billing_details: {
                                name: contactName,
                                email: auth_user_profile_creds.email},},
                            client_secret: srtripe_client_secret,
                            return_url: window.location.origin + '/eshop/bnpl-return?broadband=true&service_type=ufb',
                            checkout_url: window.location.origin + '/eshop/checkout-ufb'
                        })
                        .then(() => {
                            commit('resetBroadbandFlow')
                            return Promise.resolve(result)
                        })
                        .catch(error => {
                            return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location } })
                        })
                    }
                    else if(PaymentOptions?.PaymentMethodType == "klarna"){
                        commit('eshopUFBPurchasedSave_v2', {
                            payload,
                            result,
                            location,
                            broadband_flow: broadband_flow
                        });

                        return dispatch('stripePaymentConfirmationKlarna', {
                            card_token:{billing_details: {
                                name: contactName,
                                email: auth_user_profile_creds.email},},
                                client_secret: srtripe_client_secret,
                            return_url: window.location.origin + '/eshop/bnpl-return?broadband=true&service_type=ufb',
                            checkout_url: window.location.origin + '/eshop/checkout-ufb'
                        })
                        .then(() => {
                            commit('resetBroadbandFlow')
                            return Promise.resolve(result)
                        })
                        .catch(error => {
                            return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location } })
                        })
                    }
                    else{
                        return dispatch('stripePaymentConfirmation', {
                            card_token: payment?.cardId || getters.defaultPaymentCardId,
                            client_secret: srtripe_client_secret,
                        })
                        .then(() => {
                            commit('resetBroadbandFlow')
                        })
                        .catch(error => {
                            return Promise.reject({ ...error, srtripe_client_secret, eshopPurchasedSave_data: { payload, location } })
                        })
                    }
                }
            }).then(result => {
                commit('eshopUFBCartReset_v2', true)
                if (PaymentOptions?.PaymentMethodType !== "afterpay" && PaymentOptions?.PaymentMethodType !== "klarna") {
                    commit('eshopUFBPurchasedSave_v2', {
                        payload,
                        result,
                        location,
                        broadband_flow: broadband_flow
                    });
                }
                dynStorage.remove(ESHOP_V2_CART)

                if (payload.Items.length) {
                    const items = logAnalyticsItems(payload.Items)
                    const value = items.reduce((value, item) => value+= (item.price || 0) * (item.quantity || 0), 0)

                    const analytics_parameters = {
                        parameters: {
                            currency: "NZD",
                            value,
                            items,
                        }
                    }

                    dispatch('logAnalyticsEventPurchase', analytics_parameters)
                }

                const PrequalUUID = broadband_flow?.serviceAvailability?.PrequalUUID
                if (PrequalUUID) {
                    dispatch('ufbCheckSubscribeProduct', PrequalUUID)
                        .catch(error => {
                            console.warn('UFB product detection failed:', error)
                        })
                } else {
                    console.warn('No PrequalUUID found - UFB product auto-selection unavailable');
                }

                return Promise.resolve(result)
            })
        },

        /**
         * UFB Move House Action - Completely separate from eshopPurchaseUFB
         * Submits a move house order to relocate an existing UFB service to a new address
         * @param {Object} move_house_flow - The move house wizard flow data
         */
        eshopMoveHouseUFB({getters, commit, dispatch}, { move_house_flow }) {
            const auth_user_profile_creds = getters.auth_user_profile_creds
            const selectedPlan = move_house_flow.selectedPlan
            const newAddress = move_house_flow.newAddress

            if (!newAddress) {
                return Promise.reject(new Error('New address is required for move house'))
            }
            if (!selectedPlan) {
                return Promise.reject(new Error('Selected plan is required for move house'))
            }
            if (!move_house_flow.moveInDate) {
                return Promise.reject(new Error('Move-in date is required for move house'))
            }

            const ExistingProductUUID = getters.customer_current_product_uuid
            if (!ExistingProductUUID) {
                return Promise.reject(new Error('No active UFB service found to move'))
            }

            const currentUFBProduct = getters.customer_current_product
            const siteContactPhone = currentUFBProduct?.ActiveSiteContactPhone ||
                                    currentUFBProduct?.SiteContactPhone ||
                                    auth_user_profile_creds.phone

            if (!siteContactPhone || siteContactPhone.trim() === '') {
                return Promise.reject(new Error('Site contact phone number is required for UFB move house'))
            }

            const serviceAddress = newAddress?.Formatted ||
                `${newAddress?.Lines?.filter(line => line).join(', ')}, ${newAddress?.City}, ${newAddress?.Country}, ${newAddress?.PostCode}`.replace(/^, /, '')

            // Convert moveInDate to nanoseconds
            // Handle both Date objects and timestamp numbers
            let moveInDate = move_house_flow.moveInDate
            if (moveInDate instanceof Date) {
                moveInDate = moveInDate.getTime()
            } else if (typeof moveInDate === 'string') {
                moveInDate = new Date(moveInDate).getTime()
            }
            const ConnectionDateNanos = moveInDate * 1000000

            const contactName = [auth_user_profile_creds.first_name, auth_user_profile_creds.last_name].join(' ').trim()

            const currentTimeNanos = Date.now() * 1000000

            const payload = {
                SPID: getters.app_spid,
                UUID: getters.eshop_v2_move_house_cart_uuid || null,
                Number: getters.eshop_v2_move_house_cart_number || null,
                CustomerUUID: getters.current_account_uid,

                Address: {
                    ...toApiAddress(newAddress),
                    Email: auth_user_profile_creds.email,
                    Name: contactName,
                    Phone: "",
                },

                Items: [
                    {
                        Identifier: selectedPlan.ID,
                        UUID: selectedPlan.UUID || null,
                        ItemUUID: selectedPlan.ID,
                        ItemVariantUUID: selectedPlan.ProductCatalogUUID,
                        Type: "TYPE_VIRTUAL",
                        VirtualType: "VT_PLAN",
                        PhysicalType: "", 

                        SPID: getters.app_spid,
                        ServiceType: "UFB",
                        Name: selectedPlan.Name,
                        Brand: "",
                        Description: selectedPlan.Description || selectedPlan.Name,
                        Quantity: 1,
                        PriceCents: selectedPlan.Price || 0,  
                        AmountCents: selectedPlan.Price || 0,
                        AmountTaxCents: 0,
                        PriceCatalogCents: selectedPlan.Price || 0,
                        AmountPaidCents: 0,
                        AmountIncludesTax: false,
                        ItemImages: null,
                        Status: "CART",
                        Shipped: false,
                        Delivered: false,
                        Tracking: "",
                        TrackingURL: "",
                        TrackingNumber: "",
                        TrackingCarrier: "",

                        ProductCatalogUUID: selectedPlan.ProductCatalogUUID,
                        ProductAvailabilityUUID: selectedPlan.ID,

                        CreatedAtNanos: currentTimeNanos,
                        UpdatedAtNanos: currentTimeNanos,

                        Attributes: {
                            MobileProductAvailabilityUUID: selectedPlan.ID,
                            MobileProductCatalogUUID: selectedPlan.ProductCatalogUUID,

                            FWAAttributes: {},

                            UFBAttributes: {

                                PrequalUUID: move_house_flow.serviceAvailability?.PrequalUUID || null,
                                ServiceType: "Managed",
                                ServiceAddress: serviceAddress,
                                OrderType: "ConnectPrimary",

                                IsMoveHouse: true,
                                ExistingProductUUID: ExistingProductUUID,
                                ConnectionDateNanos: ConnectionDateNanos,

                                RSFDate: ConnectionDateNanos,

                                TransferFrom: {
                                    Provider: "",
                                    AccountHolderName: "",
                                    AccountNumber: "",
                                    ConnectionID: ""
                                }
                            },

                            ESIMInfo: {
                                ID: "",
                                Data: "",
                                ConfirmationCode: ""
                            },

                            Contact: {
                                PhoneNumber: siteContactPhone,
                                Name: contactName
                            },
                            CustomerCreation: 'ReuseTheCustomer',
                            BillingReference: "postpay",
                            AutoRenew: true,
                            SetupBillRouting: false,
                            BillRouteCustomerUUID: "",
                            MobileGroupOwnerMobileUUID: "",
                            DesiredGroupType: "",
                            BecomeGroupOwner: false,
                            SetupMobileGroup: false,
                            RequestedForName: "",
                            PortingOverMSISDN: "",
                            PortingCarrierLSP: 0,
                            PortingAccountLSP: "",
                            PortingNametagLSP: "",
                            PortingPriorSIMID: "",
                            AddIdentityAccess: false,
                            PreSelectedMSISDN: "",
                            ReplacesMobileUUID: ""
                        },

                        Products: [],
                        SelfManaged: false,
                        CustomerUUID: getters.current_account_uid,
                    }
                ],

                PaymentOptions: null
            }

            return axiosIntents.post('/eshop/v3/checkout', payload)
                .then(({ result }) => {


                    commit('eshopMoveHouseCartSave', {
                        UUID: result.UUID || payload.UUID,
                        Number: result.Number || payload.Number,
                        payload,
                        result,
                        move_house_flow
                    })


                    return Promise.resolve(result)
                })
                .catch(error => {
                    console.error('UFB Move House - Order submission failed:', error)
                    return Promise.reject(error)
                })
        },

        /**
         * Update Move House UFB Action - Updates an existing Move House order
         * This allows customers to update the RFSDate (move-in date) for a pending Move House order
         * @param {Object} params - The update parameters
         * @param {String} params.productUUID - The UUID of the new UFB product instance
         * @param {Number} params.rfsDate - The new RFSDate in nanoseconds
         */
        updateMoveHouseUFB({getters}, { productUUID, rfsDate }) {
            const customerUUID = getters.current_account_uid

            // Validate inputs
            if (!customerUUID) {
                return Promise.reject(new Error('Customer UUID is required for updating move house'))
            }
            if (!productUUID) {
                return Promise.reject(new Error('Product UUID is required for updating move house'))
            }
            if (!rfsDate) {
                return Promise.reject(new Error('RFS Date is required for updating move house'))
            }

            // API endpoint: PUT /ufb/v1/customer/{customerUUID}/order/{orderUUID}
            // The firebase_identity header is automatically added by axios-intents-middleware
            const payload = {
                RFSDate: rfsDate
            }

            return axiosIntents.put(`/ufb/v1/customer/${customerUUID}/order/${productUUID}`, payload)
                .then(({ result }) => {
                    return Promise.resolve(result)
                })
                .catch(error => {
                    console.error('Update Move House UFB - Failed:', error)
                    return Promise.reject(error)
                })
        },

        /**
         * Cancel Move House UFB Action - Cancels a pending Move House order
         * This allows customers to cancel their move house request and keep their service at the current location
         * @param {Object} params - The cancellation parameters
         * @param {String} params.productUUID - The UUID of the new UFB product instance (the one with has ProductOrderUUID)
         */
        async cancelMoveHouseUFB({getters}, { productUUID }) {
            const customerUUID = getters.current_account_uid

            // Validate inputs
            if (!customerUUID) {
                return Promise.reject(new Error('Customer UUID is required for cancelling move house'))
            }
            if (!productUUID) {
                return Promise.reject(new Error('Product UUID is required for cancelling move house'))
            }

            try {
                const response = await axiosIntents.delete(`/ufb/v1/customer/${customerUUID}/order/${productUUID}`)

                return Promise.resolve(response.result)
            } catch (error) {
                console.error('Cancel Move House UFB - Failed:', error)

                // Enhanced error parsing for user-friendly messages
                let errorMessage = 'Failed to cancel move house order. Please try again.'

                if (error?.response?.data?.err_message) {
                    errorMessage = error.response.data.err_message
                } else if (error?.response?.data?.message) {
                    errorMessage = error.response.data.message
                } else if (error?.message) {
                    errorMessage = error.message
                }

                return Promise.reject(new Error(errorMessage))
            }
        },

        /**
         * Generic UFB Order Update Action
         * Updates any field(s) on a UFB order
         * @param {Object} params - The update parameters
         * @param {String} params.customerUUID - The UUID of the customer
         * @param {String} params.orderUUID - The UUID of the order/product to update
         * @param {Object} params.payload - The payload containing fields to update
         */
        ufbUpdateOrder({}, { customerUUID, orderUUID, payload }) {
            // Validate inputs
            if (!customerUUID) {
                return Promise.reject(new Error('Customer UUID is required for updating UFB order'))
            }
            if (!orderUUID) {
                return Promise.reject(new Error('Order UUID is required for updating UFB order'))
            }
            if (!payload || Object.keys(payload).length === 0) {
                return Promise.reject(new Error('Payload is required for updating UFB order'))
            }

            // API endpoint: PUT /ufb/v1/customer/{customerUUID}/order/{orderUUID}
            return axiosIntents.put(`/ufb/v1/customer/${customerUUID}/order/${orderUUID}`, payload)
                .then(({ result }) => {
                    return Promise.resolve(result)
                })
                .catch(error => {
                    console.error('UFB Order Update - Failed:', error)
                    return Promise.reject(error)
                })
        },

        /**
         * Refresh Customer UFB Products
         * Triggers a refresh of UFB products from Firestore
         */
        refreshCustomerUFBProducts({ dispatch }) {
            // This triggers Firestore listeners to refresh UFB product data
            // The actual implementation depends on your Firestore setup
            // If you have a specific action to refresh Firestore data, call it here
            // For now, this is a placeholder that can be extended
            return Promise.resolve()
        }

    },

}
